import type { ToastAction } from './types';

type ActionByKind<K extends ToastAction['kind']> = Extract<ToastAction, { kind: K }>;

const handlers = new Map<ToastAction['kind'], (action: ToastAction) => void>();

export function registerToastActionHandler<K extends ToastAction['kind']>(
  kind: K,
  handler: (action: ActionByKind<K>) => void
): void {
  handlers.set(kind, handler as unknown as (action: ToastAction) => void);
}

export function dispatchToastAction(action: ToastAction): void {
  const handler = handlers.get(action.kind);
  if (!handler) return;
  handler(action);
}
